import { Modal } from './Modal';
import { Button } from './Button';

interface ConfirmModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  danger?: boolean;
  loading?: boolean;
}

export function ConfirmModal({
  open,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  danger = false,
  loading = false,
}: ConfirmModalProps) {
  return (
    <Modal open={open} onClose={onClose} title={title} hideCloseButton>
      <div className="flex flex-col gap-5">
        {message && <p className="text-sm text-muted leading-relaxed">{message}</p>}
        <div className="flex gap-2 justify-end">
          <Button
            variant="secondary"
            size="md"
            onClick={onClose}
            disabled={loading}
            className="!text-muted text-sm !tracking-normal rounded-xl"
          >
            {cancelLabel}
          </Button>
          <Button
            variant={danger ? 'danger' : 'primary'}
            size="md"
            onClick={onConfirm}
            loading={loading}
            loadingText="Please wait…"
            className={`text-sm !tracking-normal rounded-xl ${danger ? '!bg-danger !text-white !border-0 hover:!text-white' : ''}`}
          >
            {confirmLabel}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
